import React from 'react';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import './styles.css';

export default function GoToTopButton() {
    return (
        <div className="go-to-top"><a href="#top"><ExpandLessIcon/></a></div>
    )
}